/**
 * Saudi National Day promotion — shared constants.
 *
 * Display-only promo: the coupon is announced in the UI, the cashback itself is
 * granted backend/ops-side. Nothing here is sent with the wallet charge request.
 *
 * Palette is taken from `public/national-day.svg` (the official lockup) since the
 * app theme has no Saudi-green token — `green.main` is a generic MUI green.
 */
export const NATIONAL_DAY_COLORS = {
    green: "#00894A",
    deep: "#00343A",
    ink: "#031B20"
}

export const NATIONAL_DAY_COUPON = "KSA96"

export const NATIONAL_DAY_CASHBACK_RATE = 5

/** Cashback cap in SAR per top-up. Mirrors the coupon's cashbackLimit configured admin-side —
    keep the two in sync, the server value is the one actually enforced. */
export const NATIONAL_DAY_CASHBACK_CAP = 300

export const NATIONAL_DAY_LOGO = "/national-day.svg"

/** Checkerboard motif echoing the border of the lockup's dark block. */
export const checkerboard = (size = 14, color = NATIONAL_DAY_COLORS.green) => ({
    backgroundImage: `repeating-conic-gradient(${color} 0% 25%, transparent 0% 50%)`,
    backgroundSize: `${size}px ${size}px`
})
